import { render, staticRenderFns } from "./HomeWeekDots.vue?vue&type=template&id=213a8650&scoped=true"
import script from "./HomeWeekDots.vue?vue&type=script&lang=js"
export * from "./HomeWeekDots.vue?vue&type=script&lang=js"
import style0 from "./HomeWeekDots.vue?vue&type=style&index=0&id=213a8650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a8650",
  null
  
)

export default component.exports